import { 
    FaPython, FaJava, FaHtml5, FaCss3Alt, FaJs, FaReact, 
    FaDatabase, FaGitAlt, FaNode, FaDocker, FaAws,
    FaJira
} from "react-icons/fa";
import { 
    SiTailwindcss, SiExpress, SiMongodb, SiPostgresql,
    SiSpring, SiRedux, SiTypescript, SiPostman
} from "react-icons/si";
import { useEffect, useState } from 'react';

export default function Skills() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        const section = document.getElementById('skills');
        if (section) {
            observer.observe(section);
        }

        return () => {
            if (section) {
                observer.unobserve(section);
            }
        };
    }, []);

    const skills = [
        { name: "Python", icon: <FaPython />, color: "text-blue-500 hover:text-blue-600" },
        { name: "Java", icon: <FaJava />, color: "text-red-500 hover:text-red-600" },
        { name: "React", icon: <FaReact />, color: "text-cyan-500 hover:text-cyan-600" },
        { name: "HTML5", icon: <FaHtml5 />, color: "text-orange-500 hover:text-orange-600" },
        { name: "CSS3", icon: <FaCss3Alt />, color: "text-blue-400 hover:text-blue-500" },
        { name: "Tailwind", icon: <SiTailwindcss />, color: "text-teal-400 hover:text-teal-500" },
        { name: "Node.js", icon: <FaNode />, color: "text-green-500 hover:text-green-600" },
        { name: "MongoDB", icon: <SiMongodb />, color: "text-green-600 hover:text-green-700" },
        { name: "PostgreSQL", icon: <SiPostgresql />, color: "text-blue-400 hover:text-blue-500" },
        { name: "Spring", icon: <SiSpring />, color: "text-green-600 hover:text-green-700" },
        { name: "Git", icon: <FaGitAlt />, color: "text-orange-600 hover:text-orange-700" },
        { name: "Postman", icon: <SiPostman />, color: "text-orange-500 hover:text-orange-600" },
        { name: "Docker", icon: <FaDocker />, color: "text-blue-400 hover:text-blue-500" },
        { name: "MySQL", icon: <FaDatabase />, color: "text-blue-500 hover:text-blue-600" }
    ];

    return (
        <section id="skills" className="py-16 bg-bg-primary relative">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold mb-3 text-gray-900">
                        Tech Stack
                    </h2>
                    <p className="text-gray-600 max-w-xl mx-auto">
                        Technologies and tools I work with daily
                    </p>
                </div>

                {/* Single unified skills box */}
                <div className={`bg-white rounded-xl shadow-md p-6 transition-all duration-700 ${
                    isVisible ? 'opacity-100' : 'opacity-0'
                }`}>
                    <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-7 lg:grid-cols-10 gap-5">
                        {skills.map((skill, index) => (
                            <div
                                key={index}
                                className={`flex flex-col items-center transition-all duration-300 transform hover:-translate-y-1 ${
                                    isVisible ? 'opacity-100' : 'opacity-0'
                                }`}
                                style={{ 
                                    transitionDelay: isVisible ? `${index * 30}ms` : '0ms'
                                }}
                            >
                                <div className={`text-2xl transition-colors ${skill.color}`}>
                                    {skill.icon}
                                </div>
                                <span className="mt-2 text-xs text-gray-600 text-center">
                                    {skill.name}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}